import { render } from "./2022-11-13-View Render.md?vue&type=template&id=46215c0d"
const script = {}
script.render = render

export default script